var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: { "nudge-bottom": "12px", "close-on-content-click": false },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    { attrs: { small: "", outlined: "", color: "#006c27" } },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c("v-icon", { attrs: { left: "", small: "" } }, [
                    _vm._v("mdi-shield-edit-outline"),
                  ]),
                  _vm._v(" Override "),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { width: "380" } },
        [
          _c(
            "v-card-title",
            { staticClass: "text--secondary text-subtitle-1" },
            [_vm._v(" Global Portal Status Override ")]
          ),
          _c(
            "v-card-text",
            [
              _vm.override && _vm.override.status
                ? _c(
                    "v-alert",
                    { attrs: { dense: "", outlined: "", type: "warning" } },
                    [
                      _vm._v(
                        " Effective status is forced to " +
                          _vm._s(_vm.override.status) +
                          " for all environments. "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.override
                ? _c("div", { staticClass: "text-caption mb-3" }, [
                    _vm._v(
                      " Current: " +
                        _vm._s(_vm.override.status || "clear") +
                        " "
                    ),
                    _vm.override.updatedBy
                      ? _c("span", [
                          _vm._v(" by " + _vm._s(_vm.override.updatedBy)),
                        ])
                      : _vm._e(),
                    _vm.override.updatedAt
                      ? _c("span", [
                          _vm._v(
                            " at " +
                              _vm._s(_vm.formatDate(_vm.override.updatedAt))
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _c("v-select", {
                attrs: {
                  items: _vm.statuses,
                  label: "Effective status",
                  outlined: "",
                  dense: "",
                  color: "#006c27",
                },
                model: {
                  value: _vm.selectedStatus,
                  callback: function ($$v) {
                    _vm.selectedStatus = $$v
                  },
                  expression: "selectedStatus",
                },
              }),
              _c("v-textarea", {
                attrs: {
                  label: "Reason",
                  outlined: "",
                  dense: "",
                  rows: "2",
                  counter: "500",
                  rules: [
                    (value) =>
                      !!(value && value.trim()) || "Reason is required",
                  ],
                },
                model: {
                  value: _vm.reason,
                  callback: function ($$v) {
                    _vm.reason = $$v
                  },
                  expression: "reason",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "", disabled: _vm.loading },
                  on: {
                    click: function ($event) {
                      _vm.menu = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "#006c27",
                    dark: "",
                    loading: _vm.loading,
                    disabled: !_vm.reason || !_vm.reason.trim(),
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v(" Apply ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }